module.exports = __webpack_public_path__ + "img/48.8aa0b4f8.png";